import { render, staticRenderFns } from "./EditarImagemJornalzinho.vue?vue&type=template&id=1582adab&"
import script from "./EditarImagemJornalzinho.vue?vue&type=script&lang=js&"
export * from "./EditarImagemJornalzinho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports